import { MACRO_ACTION_TYPES as macroActionTypes } from 'dashboard/routes/dashboard/settings/macros/constants.js';
export const emptyMacro = {
  name: '',
  actions: [
    {
      action_name: 'assign_team',
      action_params: [],
    },
  ],
  visibility: 'global',
};

export const resolveActionName = key => {
  return macroActionTypes.find(i => i.key === key).label;
};

export const resolveTeamIds = (teams, ids) => {
  return ids
    .map(id => {
      const team = teams.find(i => i.id === id);
      return team ? team.name : '';
    })
    .join(', ');
};

export const resolveLabels = (labels, ids) => {
  return ids
    .map(id => {
      const label = labels.find(i => i.title === id);
      return label ? label.title : '';
    })
    .join(', ');
};

export const resolveAgents = (agents, ids) => {
  return ids
    .map(id => {
      const agent = agents.find(i => i.id === id);
      return agent ? agent.name : '';
    })
    .join(', ');
};

const isApprovedWhatsAppTemplate = template =>
  Boolean(template) && String(template.status || '').toUpperCase() === 'APPROVED';

const templateMatchesSavedId = (template, savedId) => {
  if (savedId == null || savedId === '' || !template) return false;
  return (
    String(template.id) === String(savedId) || template.name === savedId
  );
};

export const collectApprovedWhatsAppTemplates = inboxes => {
  return (inboxes || [])
    .filter(inbox => inbox.channel_type === 'Channel::Whatsapp')
    .flatMap(inbox => inbox.message_templates || [])
    .filter(isApprovedWhatsAppTemplate);
};

export const resolveWhatsAppTemplate = (inboxes, dropdownTemplates, savedId) => {
  if (savedId == null || savedId === '') return null;

  const fromInboxes = collectApprovedWhatsAppTemplates(inboxes).find(template =>
    templateMatchesSavedId(template, savedId)
  );
  if (fromInboxes) return fromInboxes;

  return (dropdownTemplates || []).find(template =>
    templateMatchesSavedId(template, savedId)
  ) || null;
};

export const hydrateWhatsAppActionParams = (actionParams, template) => {
  const savedId = Array.isArray(actionParams) ? actionParams[0] : actionParams?.id;
  if (!template && (savedId == null || savedId === '')) return [];

  const base = template ? { ...template } : { id: savedId, name: String(savedId) };
  if (Array.isArray(actionParams) && actionParams.length > 1) {
    base.components = [
      {
        header_handle: actionParams[2],
        text: actionParams[1],
        format: actionParams[3] || null,
      },
    ];
  }
  return base;
};

export const getFileName = (id, actionType, files) => {
  if (!id || !files) return '';
  if (actionType === 'send_attachment') {
    const file = files.find(item => item.blob_id === id);
    if (file) return file.filename.toString();
  }
  return '';
};
